import 'reflect-metadata';
import { container } from 'tsyringe';
import { GetLocations } from './getLocations';
import { GetLocationsByName } from './getLocationsByName';
import { GetLocationsByNameClassic } from './getLocationsByNameClassic';
import { GetLocationByCode } from './getLocationByCode';
import { AnalizeFingerprint } from '../fingerprint/analizeFingerprint';
export const DependencyInjectionLocationsInfrastructure = () => {
    container.register("iGetLocations", { useClass: GetLocations });
    container.register("iGetLocationsByName", { useClass: GetLocationsByName });
    container.register("iGetLocationsByNameClassic", { useClass: GetLocationsByNameClassic });
    container.register("iGetLocationByCode", { useClass: GetLocationByCode });
    container.register("iAnalizeFingerprint", { useClass: AnalizeFingerprint });
};
export default DependencyInjectionLocationsInfrastructure;
